import $ from "jquery";

$("[data-template-included-excluded-item]").on("click tap", (event) => {
    event.preventDefault();

    $(event.currentTarget).toggleClass("s_is-open");
});

/**
 * RTF Data Loader
 * Dynamically loads RTF calendar HTML to bypass Kinsta cache
 */
const RTFDataLoader = {
    init() {
        const $loaders = $("[data-rtf-loader]");
        if ($loaders.length === 0) return;

        $loaders.each((_, element) => {
            this.loadRTFData($(element));
        });
    },

    async loadRTFData($loader) {
        const templateId = $loader.data("template-id");
        const apiUrl = $loader.data("api-url");

        if (!templateId || !apiUrl) {
            this.showError($loader, "Missing configuration");
            return;
        }

        try {
            const response = await fetch(`${apiUrl}?template-id=${templateId}`);
            const data = await response.json();

            if (!data.success) {
                this.hideLoader($loader);
                return;
            }

            if (!data.data.has_rtf_data || !data.data.calendar_html) {
                this.hideLoader($loader);
                return;
            }

            this.setHasRtfs(true);

            // Insert the pre-rendered calendar HTML
            $loader.html(data.data.calendar_html);

            // Initialize the RTF calendar component
            const $calendar = $loader.find("[data-rtf-calendar]");
            if ($calendar.length > 0) {
                if (typeof window.RTFCalendar !== "undefined") {
                    window.RTFCalendar.initCalendar($calendar);
                } else {
                    // Dispatch custom event for the RTF calendar to pick up
                    window.dispatchEvent(
                        new CustomEvent("rtf-calendar-loaded", {
                            detail: { element: $calendar[0] },
                        })
                    );
                }
            }
        } catch (error) {
            console.error("Failed to load RTF data:", error);
            this.hideLoader($loader);
        }
    },

    hideLoader($loader) {
        // Hide the entire RTF container if no data
        $loader.closest(".sb_template-included-excluded_rtf-container").hide();
        this.setHasRtfs(false);
    },

    /**
     * Single source of truth for "this trip has bookable departures right now".
     *
     * The page is cached, so the server-side guess (body class set in
     * single-template.php) can be stale — this corrects it once the RTF fetch
     * resolves. Drives which buttons show in both the sticky bar and the
     * "Inbegrepen in je reis" section, plus the border radius of that section.
     */
    setHasRtfs(hasRtfs) {
        $("body").toggleClass("s_has-rtfs", hasRtfs);
    },

    showError($loader, message) {
        console.error("RTF Loader Error:", message);
        this.hideLoader($loader);
    },
};

// Initialize when DOM is ready
$(document).ready(() => {
    RTFDataLoader.init();
});
